/**
 * Returns the node of the conditions block
 * 
 * @param {String} conditionsBlockID The unique ID of the conditions block
 * @returns {Node} The node of the conditions block
 */
const getConditionsBlockNode = ( conditionsBlockID ) => {
	return document.querySelector( `.uap-conditions-block[data-id="${ conditionsBlockID }"]` );
}

export default getConditionsBlockNode;
